import {Circle, IHitArea, Rectangle, Sprite} from 'pixi.js';
import {Button as ButtonConstructor} from '@gongxigames/framework/core/fragments/display';
import {Context} from '@gongxigames/framework/core/fragments/BuilderX/types';
import {Component, ComponentProps} from './Component';
import {SpriteProps} from './Sprite';

export type HitAreaProps = {
    x: number;
    y: number;
    width: number;
    height: number;
    type: 'rectangle';
} | {
    x: number;
    y: number;
    radius: number;
    type: 'circle';
};

export type ButtonProps = SpriteProps & {
    hitArea?: HitAreaProps;
};

export class Button extends Component<ButtonProps, ButtonConstructor> {
    public readonly jsxType: string = 'button';

    static propsFromJson(props: any): ButtonProps {
        const propsNormalized = {
            ...super.propsFromJson(props),
            hitArea: props.hitarea
        };

        return propsNormalized;
    }

    public clone(): Button {
        return new Button(this.props);
    }

    public propsToJson(): any {
        const result = super.propsToJson();

        if (this.props.hitArea) {
            result.hitarea = this.props.hitArea;
        }

        result.frames = result.children;
        delete result.children;

        return result;
    }

    public getConstructor(): new () => any {
        return ButtonConstructor;
    }

    public getChildrenToPixi(): Component<ComponentProps>[] {
        return [];
    }

    public buildGeom(conf: HitAreaProps): IHitArea | null {
        if (conf.type === 'circle') {
            return new Circle(conf.x || 0, conf.y || 0, conf.radius);
        } else if (conf.type === 'rectangle' && conf.width !== -1 && conf.height !== -1) {
            return new Rectangle(conf.x || 0, conf.y || 0, conf.width, conf.height);
        }

        return null;
    }

    public updateBaseProps(context: Context, container: ButtonConstructor, element: ButtonConstructor): void {
        const props = this.props;

        if (!props.children) {
            throw new Error('MovieClip should contain children');
        }

        const children = props.children as any as Component<ComponentProps>[];
        const oldFrames = [...container.children];

        container.removeChildren();

        const frames = children.map((item, i) => {
            const oldChild = oldFrames[i] as Sprite;
            const constructor = this.getConstructor();

            if (container instanceof constructor) {
                return item.build({context, element: oldChild});
            }

            return item.build({context});
        }) as Sprite[];

        container.setFrames(frames[0], frames[2], frames[1], frames[3]);

        if (props.hitArea) {
            container.hitArea = this.buildGeom(props.hitArea);
        }

        super.updateBaseProps(context, container, element);
    }
}
